import { render, staticRenderFns } from "./GymRegister.vue?vue&type=template&id=fd4d74f2"
import script from "./GymRegister.vue?vue&type=script&lang=js"
export * from "./GymRegister.vue?vue&type=script&lang=js"
import style0 from "./GymRegister.vue?vue&type=style&index=0&id=fd4d74f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports